<template>
  <div class="row">
    <div class="col-12">
      <card>
        <div class="card-body">
          <div class="row" v-if="isAdmin">
            <div class="col-12">
              <div class="float-right mb-4">
                <button class="btn btn-secondary btn-sm" @click="export2Excel">
                  <i class="fas fa-download fa-fw"></i> Download XLS
                </button>
              </div>
            </div>
          </div>

          <v-server-table ref="vuetable" url="/dtable/requests" :columns="columns" :options="options">
            <template slot="beforeFilter">
              <h2>
                <i class="fas fa-file-invoice text-primary"></i> {{$t('request.title')}}
              </h2>
            </template>
            <template slot="beforeTable"  v-if="showIfRoleIs('admin,admin-rede')">
              <div class="row">
                <div class="col-md-6 mb-4 px-0 pb-3" v-if="showIfRoleIs('admin,admin-rede')">
                  <label class="text-uppercase text-muted mb-0 mr-2 d-inline-block align-middle">
                    <small>{{$t('part.text.filterbyasf')}}:</small>
                  </label>

                  <div class="d-flex align-items-center">
                    <multiselect
                      v-model="asf_value"
                      :options="asfs"
                      :custom-label="asfLabel"
                      :placeholder="$t('text.select')"
                      label="name"
                      track-by="id"
                      class="b-form-btn-label-control flex-fill mr-2"
                      @open="getAsfs"
                      @input="onAsfFilterChange($event ? $event.id : null)"
                    ></multiselect>

                    <a
                      @click.prevent="selectAllAsfs"
                      class="btn btn-primary px-3 rounded"
                      href
                    >
                      {{$t('button.allAsfs')}}
                    </a>
                  </div>
                </div>

                 <div class="col-md-4">
                  <label class="text-uppercase text-muted mb-0 mr-2 d-inline-block align-middle" for>
                    <small>{{$t('request.status')}}:</small>
                  </label>
                  <select
                      class="form-control"
                      v-model="form.status"
                      @change="onStatusFilterChange"
                  >
                      <option value>{{$t('request.text.select')}}</option>
                      <option value="new">{{$t('request.option.new')}}</option>
                      <option value="in_analysis">{{$t('request.option.in_analysis')}}</option>
                      <option value="analysis_completed">{{$t('request.option.analysis_completed')}}</option>
                      <option value="in transit">{{$t('request.option.intransit')}}</option>
                      <option value="completed">{{$t('request.option.completed')}}</option>
                      <option value="canceled">{{$t('request.option.canceled')}}</option>
                  </select>
                </div>
              </div>

            </template>
            <template
                slot="status"
                slot-scope="props"
            >{{ $t('request.option.' + props.row.status.toLowerCase().replace(/\s/g, '')) }}</template>
            <template slot="afterLimit">
              <router-link class="btn btn-primary ml-2" :to="{ name: 'request_parts'}">
                <i class="fas fa-plus fa-fw"></i> {{$t('request.button.addnew')}}
              </router-link>
            </template>
            <template slot="early_kit" slot-scope="props">
              <span v-if="props.row.early_kit" class="badge badge-success text-white">{{$t('request.earlykit')}}</span>
            </template>
            <template slot="id" slot-scope="props" class="btn-group" role="group">
              <router-link
                class="btn btn-xs btn-primary mr-1"
                :to="{ name: 'requests_edit', params: { id: props.row.id } }"
              >
                <i class="fas fa-edit fa-fw"></i>
              </router-link>
              <router-link
                class="btn btn-xs btn-primary mr-1"
                :to="{ name: 'requests_delete', params: { id: props.row.id } }"
                 v-if="isAdmin"
              >
                <i class="fas fa-trash-alt fa-fw"></i>
              </router-link>
            </template>

            <template slot="created_at" slot-scope="props">
              {{ convertToGMT3(props.row.created_at) }}
            </template>
          </v-server-table>
        </div>
      </card>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
export default {
  computed: {
     ...mapState("asfs", {
      asfs: "all"
    }),
    isAdmin() {
      return this.$store.getters["auth/getIsAdmin"];
    }
  },
  data() {
    return {
      asf_value: "",
      form: {
        status: null
      },
      columns: [
        "request_code",
        "name",
        "status",
        "repair_id",
        "early_kit",
        "invoice_number",
        "created_at",
        "id"
      ],
      options: {
        orderBy: {
          ascending: false,
          column: "created_at"
        },
        dateColumns: ["created_at"],
        perPage: 10,
        perPageValues: [10, 25, 50, 100],
        headings: {
          request_code: () => this.$t('request.code'),
          repair_id: () => this.$t('request.repairid'),
          name: () => this.$t('request.asf'),
          status: () => this.$t('request.status'),
          early_kit: "",
          invoice_number: () => this.$t('request.invoicenumber'),
          created_at: () => this.$t('request.createdat'),
          id: ""
        },
        texts: {
          count: this.$t('field.count'),
          filter: this.$t('field.filter'),
          filterPlaceholder: this.$t('field.filterplaceholder'),
          limit: this.$t('field.limit'),
        },
        columnsClasses: { id: "text-right" },
        skin: "table table-sm table-hover",
        pagination: {
          edge: true
        },
        params: {
          asf: this.$store.getters["auth/getCurrentAsf"],
          asf_id: null,
          status: null
        },
        sortIcon: {
          base: "fas fa-sort",
          up: "fas fa-sort-up",
          down: "fas fa-sort-down",
          is: "fas fa-sort"
        }
      }
    };
  },
  methods: {
    onStatusFilterChange() {
      this.options.params.status = this.form.status || null;

      this.$nextTick(() => {
        this.$refs.vuetable.refresh();
      });
    },
    asfLabel({ name, vat }) {
      return `${name} — ${vat}`;
    },
    selectAllAsfs() {
      this.asf_value = null;
      this.options.params.asf_id = null;

      this.$nextTick(() => {
        this.$refs.vuetable.refresh();
      });
    },
    showIfRoleIs(role) {
      return this.$store.getters["auth/isInRoles"](role);
    },
    getAsfs() {
      this.$store.dispatch("asfs/getAllAsfs", "name");
    },
    onFilterSet(e) {
      if (e && e.target) {
        this.options.params.asf_id = e.target.getAttribute("data-asf-id");
      }

      this.$nextTick(() => {
        this.$refs.vuetable.refresh();
      });
    },
    onAsfFilterChange(selectedAsf) {
      this.options.params.asf_id = selectedAsf ?? null;
      this.onFilterSet();
    },
    getCurrentDate() {
      var myDate = new Date();
      var month = ('0' + (myDate.getMonth() + 1)).slice(-2);
      var day = ('0' + myDate.getDate()).slice(-2);
      var year = myDate.getFullYear();
      return year + '-' + month + '-' + day;
    },
    export2Excel() {
      import('@/excel/Export2Excel').then(excel => {
        const tHeader = this.columns.slice(0, -1); // Definir título da primeira linha do Excel
        const filterVal = this.columns.slice(0, -1); // Propriedades dos objetos para serem exportadas
        const list = this.$refs.vuetable.data; // Dados da tabela
        const data = this.formatJson(filterVal, list);

        excel.export_json_to_excel({
          header: tHeader, // Cabeçalho
          data, // Dados a serem exportados
          filename: this.$t('global.request_export') + '_' + this.getCurrentDate(), // Nome do arquivo
          autoWidth: true, // Largura automática
          bookType: 'xlsx' // Tipo do arquivo
        });
      });
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map(v =>
        filterVal.map(j => j === 'created_at' ? this.convertToGMT3(v[j]) : v[j])
      );
    },
    convertToGMT3(dateString) {
      if (!dateString) return "";

      const date = new Date(dateString); // Converte a string para um objeto Date
      const offset = -1; // GMT-3

      // Ajuste da hora para GMT-3
      date.setHours(date.getHours() + offset);

      // Formatação da data para o formato 'dd/MM/yyyy HH:mm:ss'
      const day = ('0' + date.getDate()).slice(-2);
      const month = ('0' + (date.getMonth() + 1)).slice(-2);
      const year = date.getFullYear();
      const hours = ('0' + date.getHours()).slice(-2);
      const minutes = ('0' + date.getMinutes()).slice(-2);
      const seconds = ('0' + date.getSeconds()).slice(-2);

      return `${day}/${month}/${year} ${hours}:${minutes}:${seconds}`;
    }
  }
};
</script>
<style>
</style>
